import { isProd, isStage, isDev, isTestBed, isBusiness, isLocal } from './env';

const devVersionPrefix = '/v1.1';
const stageVersionPrefix = '/v1.1';
const prodVersionPrefix = '/v1.1';

const apiUrl = () => {
  // business should be first here
  // cause isProd includes isBusiness
  if (isBusiness())
    return `https://api-business.wingalpha.com${prodVersionPrefix}/api/`;
  if (isProd()) return `https://api.wingalpha.com${prodVersionPrefix}/api/`;
  if (isLocal())
    return `https://api-stage.wingalpha.com${devVersionPrefix}/api/`;
  if (isStage())
    return `https://api-stage.wingalpha.com${stageVersionPrefix}/api/`;
  if (isDev()) return `https://api-dev.wingalpha.com${devVersionPrefix}/api/`;
  if (isTestBed) return `'https://api-testbed.wingalpha.com/api/`;
};

const userDashboardUrl = () => {
  if (isProd()) return 'https://dashboard.wingalpha.com';
  if (isStage()) return 'https://dashboard-stage.wingalpha.com';
  if (isDev()) return 'https://dashboard-dev.wingalpha.com';
};

const layoverUser = () => {
  if (isProd()) return 16883;
  if (isStage() || isDev()) return 1;
};

const getUsersWithRechargeSubId = () => {
  if (isProd()) return [202014, 197502, 186392];
  if (isDev()) return [];

  return [1364];
};

export const API_URL = apiUrl();
export const USER_DASHBOARD_URL = userDashboardUrl();
export const LAYOVER_USER = layoverUser();
export const USERS_WITH_RECHARGE_SUB_ID = getUsersWithRechargeSubId();

export const USAGE_DATE_FORMAT = 'M/D/YYYY';
export const DATE_TIME_FORMAT = 'M/D/YYYY h:mm A';
export const YEAR_DATE_FORMAT = 'YYYY-MM-DD';

export const USER_ACL_GROUPS = [
  'ADMIN',
  'MANAGER',
  'AGENT',
  'BUSINESS',
  'USER',
  'RESELLER',
  'BILLING',
  'TRAINEE',
];

export const INTERCOM_ID = 'uo48draq';

export const BIG_PAGE_SIZE = 1000;
